import withDraft from '@/utils/draftHelper';
import actions from '@/requests/subscriptions/constants';
import handleDatasetSubscribeSuccess from './state';

const subscribeToRequestDatasetSuccess = withDraft((draft, { datasetCode, subscriptions }) => {
  handleDatasetSubscribeSuccess(draft, { code: datasetCode, subscriptions });
});

export default {
  [actions.SUBSCRIBE_TO_REQUEST_DATASET_SUCCESS]: subscribeToRequestDatasetSuccess,
};
